<template>
    <b-table striped hover :fields="fields" :items="subjects" :filter="filter">
        <template v-slot:cell(name)="data">
            <b-link :href="data.item.case_link" target="_blank">{{ data.item.name }}</b-link>
        </template>
        <template v-slot:cell(approve)="data">

            <!-- Only show approve/decline buttons for new requests -->
            <b-button v-if="data.item.final_status == 'New Request' && data.item.unresolved_aesae.length == 0 && data.item.withdrawn == 'true'" @click="approve(data.index)" size="sm" variant="success" class="w-20">Approve</b-button>
            <b-button v-if="data.item.final_status == 'New Request' && data.item.unresolved_aesae.length == 0" @click="decline(data.index)" size="sm" variant="danger" class="w-20 ml-2">Decline</b-button>

            <!-- <span v-if="data.item.final_status == 'New Request' && data.item.unresolved_aesae.length == 0 && data.item.withdrawn != 'true'">Waiting for Subject Withdrawal Form</span> -->
            <b-link v-if="data.item.unresolved_aesae.length > 0" v-b-modal="'aesae_list_modal'" @click="$root.$emit('viewAeSaeList', data.index)">Unresolved AE/SAE List</b-link>

            <!-- Otherwise, if it has been approved (and waiting for Final Status) -->
            <div v-if="data.item.final_status == 'Approved'">
                Approved on {{ data.item.last_status_changed }}
            </div>

            <!-- Otherwise, if it has been declined -->
            <div v-if="data.item.final_status == 'Declined'">
                Declined on {{ data.item.last_status_changed }}
            </div>

            <!-- And for those that are already completed... -->
            <div v-if="data.item.final_status == 'Final Status Form Completed'">
                Final Status Form completed on {{ data.item.last_status_changed }}
            </div>
            
        </template>

        <template v-slot:cell(final_status)="data">
            <span v-if="data.item.final_status == 'New Request' && data.item.unresolved_aesae.length == 0 && data.item.withdrawn != 'true'">Waiting for Subject Withdrawal Form</span>
            <span v-else>{{ data.value }}</span>
        </template>
    </b-table>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import { mapActions, mapState } from "vuex";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      fields: [
        { key: "name" },
        { key: "village" },
        { key: "reason" },
        { key: "last_followup_date"},
        { key: "approve", label: "Approve for Final Status"},
        { key: "final_status",  sortable: true, label: "Status"}
      ],
      aesae_list_fields: [
        { key: "date", label: "AE/SAE Date" },
        { key: "is_ae_sae", label: "Type" },
        { key: "status" },
        { key: "outcome" },
        { key: "ae_sae_id", label: "AE/SAE ID" },
      ],
      subjects: [],
      componentKey: 0,
      filter: null,
      active_aesae_list: [],
      active_aesae_modal_title: 'AE/SAE Cases',
    };
  },
  computed: {

    ...mapState("user", ["user", "myGroups"]),
  },
  mounted: function() {
    let that = this;
    HTTP.get("/kenya/subject_final_status/get_new").then(response => {
      that.subjects = response.data;
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  methods: {
     ...mapActions('subjectfinalstatus', 
            ['getSubjectFinalCount', 'setSubjectFinalCount']),
     ...mapActions('subjectfinalstatuscompleted', 
            ['getSubjectFinalCompletedCount', 'setSubjectFinalCompletedCount']),
    refreshSideNavCount(){
      this.getSubjectFinalCount().then((response) => {
                this.setSubjectFinalCount(response.data);
            });
    },
    approve: function(index){
      let that = this;
      HTTP.post("/kenya/subject_final_status/"+that.subjects[index].id+"/", {
        status: 'approve'
      }).then(response => {
          that.subjects.splice(index, 1, response.data);
          that.refreshSideNavCount();
      });


    },
    decline: function(index){
      let that = this;
      HTTP.post("/kenya/subject_final_status/"+that.subjects[index].id+"/", {
        status: 'decline'
      }).then(response => {
          that.subjects.splice(index, 1, response.data);
          that.refreshSideNavCount();
      });
    }
  }
};
</script>